export default __webpack_public_path__ + "static/media/bice-vida-result.616df744.png";